import { render, staticRenderFns } from "./GroupMembersForm.vue?vue&type=template&id=4487089a&scoped=true"
import script from "./GroupMembersForm.vue?vue&type=script&lang=js"
export * from "./GroupMembersForm.vue?vue&type=script&lang=js"
import style0 from "./GroupMembersForm.vue?vue&type=style&index=0&id=4487089a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4487089a",
  null
  
)

export default component.exports